import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Home as HomeIcon } from "lucide-react";
import RealLogo from "./RealLogo";
import { CONTACT, NAV_ITEMS } from "../mock";

const ZILLOW_URL = "https://www.zillow.com/profile/rogerminner#listings-and-sales";
const INSTAGRAM_URL = "https://www.instagram.com/minnerroger/";

const Footer = () => {
  return (
    <footer className="bg-[#3a3736] text-[#e7e0da]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          {/* Brand */}
          <div>
            <span className="brand-title text-2xl text-white block" style={{ letterSpacing: "0.12em" }}>
              ROGER MINNER
            </span>
            <span className="font-sans-el text-[0.62rem] tracking-[0.42em] uppercase text-[#b6a4a7] mt-1 block">
              Homes
            </span>
            <p className="font-serif-el text-lg mt-5 leading-relaxed text-[#cfc6c0]">
              {CONTACT.name}, Realtor — {CONTACT.area}. {CONTACT.specialist}.
            </p>
          </div>

          {/* Links */}
          <div className="md:justify-self-center">
            <h4 className="section-title text-sm text-[#b6a4a7] mb-4">Explore</h4>
            <ul className="space-y-2">
              {NAV_ITEMS.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="font-sans-el text-[#d8d0ca] hover:text-white transition-colors duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact + logo */}
          <div className="md:justify-self-end">
            <h4 className="section-title text-sm text-[#b6a4a7] mb-4">Get In Touch</h4>
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              className="flex items-center gap-3 group mb-3"
            >
              <Phone size={18} className="text-[#b6a4a7]" />
              <span className="font-display text-2xl text-white group-hover:text-[#b6a4a7] transition-colors tracking-wide">
                {CONTACT.phone}
              </span>
            </a>
            <div className="flex items-start gap-3 mb-6">
              <MapPin size={18} className="text-[#b6a4a7] mt-1 shrink-0" />
              <span className="font-serif-el text-base text-[#cfc6c0]">{CONTACT.address}</span>
            </div>
            <div className="real-logo" style={{ borderColor: "#fff", background: "transparent" }}>
              <span className="real-word">real</span>
              <span className="real-sub">Broker, LLC</span>
            </div>

            {/* Social links */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href={ZILLOW_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Roger Minner on Zillow"
                className="flex items-center justify-center w-11 h-11 rounded-full border border-[#5c5755] text-[#d8d0ca] hover:bg-[#b6a4a7] hover:text-white hover:border-[#b6a4a7] transition-all duration-300"
              >
                <HomeIcon size={18} />
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Roger Minner on Instagram"
                className="flex items-center justify-center w-11 h-11 rounded-full border border-[#5c5755] text-[#d8d0ca] hover:bg-[#b6a4a7] hover:text-white hover:border-[#b6a4a7] transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="h-px bg-[#4f4b49] my-9" />

        <p className="font-sans-el text-xs leading-relaxed text-[#a8a09b] max-w-4xl">
          We support the Fair Housing Act and do not discriminate based on race, color, religion, sex,
          disability, familial status, or national origin.
        </p>
        <p className="font-sans-el text-xs text-[#7f7873] mt-4">
          © {new Date().getFullYear()} Roger Minner Homes. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
